window.config = {
    'isOnAzureCloud': true,
    'authMethod': 'OAUTH',
    'servicenameSubstitution': { 'api_v1_dashboard': 'analytics' },
    'configURL': {
    },
}